module.exports = __webpack_public_path__ + "static/ImpulsePartners-c4c33c5d89d1b06b8d182cc2c6387013.png";